export default __webpack_public_path__ + "static/media/mission.62a7a862.jpg";